export default (state, { payload: { variantIds } }) => ({
  ...state,
  variantIds
});
